"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var WindowSettings = /** @class */ (function () {
    function WindowSettings(window) {
        this._data = {};
        this._window = window;
    }
    Object.defineProperty(WindowSettings.prototype, "data", {
        get: function () {
            return Object.assign({}, this._data);
        },
        set: function (value) {
            this.setData(value);
        },
        enumerable: true,
        configurable: true
    });
    WindowSettings.prototype.setData = function (data) {
        this._data = Object.assign({}, this._data, data);
    };
    Object.defineProperty(WindowSettings.prototype, "borderWidth", {
        get: function () {
            var borderWidth = this._borderWidth;
            if (borderWidth === undefined) {
                var mgr = this._window ? this._window.manager : undefined;
                if (mgr) {
                    borderWidth = mgr.windowSettings.borderWidth;
                }
            }
            return borderWidth !== undefined ? borderWidth : 0;
        },
        set: function (value) {
            this.setBorderWidth(value);
        },
        enumerable: true,
        configurable: true
    });
    WindowSettings.prototype.setBorderWidth = function (borderWidth) {
        if (borderWidth >= 0) {
            this._borderWidth = borderWidth;
        }
    };
    Object.defineProperty(WindowSettings.prototype, "headerHeight", {
        get: function () {
            var headerHeight = this._headerHeight;
            if (headerHeight === undefined) {
                var mgr = this._window ? this._window.manager : undefined;
                if (mgr) {
                    headerHeight = mgr.windowSettings.headerHeight;
                }
            }
            return headerHeight !== undefined ? headerHeight : 0;
        },
        set: function (value) {
            this.setHeaderHeight(value);
        },
        enumerable: true,
        configurable: true
    });
    WindowSettings.prototype.setHeaderHeight = function (headerHeight) {
        if (headerHeight >= 0) {
            this._headerHeight = headerHeight;
        }
    };
    Object.defineProperty(WindowSettings.prototype, "config", {
        get: function () {
            return {
                borderWidth: this._borderWidth,
                headerHeight: this._headerHeight,
                data: this.data
            };
        },
        set: function (value) {
            this.setConfig(value);
        },
        enumerable: true,
        configurable: true
    });
    WindowSettings.prototype.setConfig = function (config) {
        this.setBorderWidth(config ? config.borderWidth : undefined);
        this.setHeaderHeight(config ? config.headerHeight : undefined);
        this.setData(config ? config.data : undefined);
    };
    WindowSettings.prototype.toJSON = function () {
        return this.config;
    };
    __decorate([
        mobx_1.observable
    ], WindowSettings.prototype, "_window", void 0);
    __decorate([
        mobx_1.observable
    ], WindowSettings.prototype, "_borderWidth", void 0);
    __decorate([
        mobx_1.observable
    ], WindowSettings.prototype, "_headerHeight", void 0);
    __decorate([
        mobx_1.observable
    ], WindowSettings.prototype, "_data", void 0);
    __decorate([
        mobx_1.computed
    ], WindowSettings.prototype, "data", null);
    __decorate([
        mobx_1.action
    ], WindowSettings.prototype, "setData", null);
    __decorate([
        mobx_1.computed
    ], WindowSettings.prototype, "borderWidth", null);
    __decorate([
        mobx_1.action
    ], WindowSettings.prototype, "setBorderWidth", null);
    __decorate([
        mobx_1.computed
    ], WindowSettings.prototype, "headerHeight", null);
    __decorate([
        mobx_1.action
    ], WindowSettings.prototype, "setHeaderHeight", null);
    __decorate([
        mobx_1.computed
    ], WindowSettings.prototype, "config", null);
    __decorate([
        mobx_1.action
    ], WindowSettings.prototype, "setConfig", null);
    return WindowSettings;
}());
exports.WindowSettings = WindowSettings;
